export const ADD_GROUP_FIELDS = {
  GROUP_NAME: "groupName",
  USER_NAME: "userName",
};

